module.exports = __webpack_public_path__ + "img/loginAvatar.7ba24d47.svg";